export default {
  "no-bread-crumbs": () => import("/home/runner/work/famitei.co.jp-web2/famitei.co.jp-web2/web/layouts/NoBreadCrumbs.vue").then(m => m.default || m),
  default: () => import("/home/runner/work/famitei.co.jp-web2/famitei.co.jp-web2/web/layouts/default.vue").then(m => m.default || m)
}